import { SHOW_COOKIE_PREFERENCES_MODAL, HIDE_COOKIE_PREFERENCES_MODAL } from './actions';

const initialState = {
    showModal: false
};

export default function cookieConsent(state = initialState, action) {
    switch (action.type) {
        case SHOW_COOKIE_PREFERENCES_MODAL:
            return { ...state, showModal: true };
        case HIDE_COOKIE_PREFERENCES_MODAL:
            return { ...state, showModal: false };
        default:
            return state;
    }
} 